import AnswerButtonGroup from "@/components/train/AnswerButtonGroup";
import E808ETriangle from "@/components/subject/E808E/E808ETriangle";
export default {
  name: "E808ERender",
  components: {
    E808ETriangle,
    AnswerButtonGroup
  },
  props: {
    difficulty: {
      type: Object,
      default: () => {
        return {
          flashInterval: 10
        };
      }
    },
    review: {
      type: Object,
      default: () => {
        return null;
      }
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  data() {
    return {
      timeout: null,
      example: 0,
      letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    };
  },
  watch: {
    data() {
      this.init();
    }
  },
  methods: {
    showExample() {
      this.example++;
      this.timeout = setTimeout(() => {
        this.example++;
      }, this.difficulty.flashInterval * 1000);
    },
    init() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.example = 0;
    },
    onChoosed(l) {
      this.$emit('answer', l && l.length > 0 ? l.join(',') : null);
    }
  },
  mounted() {
    this.init();
  }
};